// Single source of truth for the sales-flow sessionStorage keys.
//
// These hold the in-progress visit → prescription → frame → measures → payment
// state so a salesperson can move between steps without losing data. They must
// be cleared at two boundaries only:
//   • starting a NEW visit  (New Visit button, "New Order", manager entry)
//   • logging out
//
// Resuming an incomplete client (Unsuccessful Orders) does NOT rely on these —
// it rebuilds the needed keys from the saved DB record — so clearing here never
// breaks resume.
import { PAIR_SESSION_KEYS } from './salePairs';

export const SALES_FLOW_KEYS = [
  // order
  'orderData', 'orderId', 'orderNumber', 'orderSummary',
  // visitor
  'visitorId', 'visitorData', 'visitorFormData', 'visitorTimeTaken', 'returningClientData', 'previousPrescription', 'salesStore',
  // prescription
  'prescriptionId', 'existingPrescription', 'prescriptionFormData',
  'prescriptionPhotoState', 'prescriptionOrderState', 'hasPrescriptionPhoto',
  // frame + lens
  'selectedFrame', 'selectedLens', 'frameSelectionData',
  // measures
  'measurementData', 'measurementFormData',
  // payment
  'paymentData', 'paymentFormData',
  // two-pair ("Both") sale
  'extraFrames', ...PAIR_SESSION_KEYS,
];

// Wipe the entire in-progress sales flow from sessionStorage.
export function clearSalesFlowSession() {
  SALES_FLOW_KEYS.forEach((key) => sessionStorage.removeItem(key));
}
